<script>
  import options from './EditProfileForm.options'
  export default options
</script>

<template>
  <article class="kb-edit-profile-form">
    
    <div class="kb-edit-profile-form-title">

      <h1 class="kb-edit-profile-form-title__title">{{ getLabel('title') }}</h1>
        
      <div class="kb-edit-profile-form-title__breaker">
        <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z"></path></svg>
      </div>
  
      <p class="kb-edit-profile-form-title__description">
        {{ getLabel('description') }}
      </p>

    </div>

    <div class="kb-stafet-donation-flow__step">

      <section class="kb-stafet-step kb-optimizely-forms">
        <h2 class="kb-stafet-step__title">
          {{ getLabel('subTitle') }}
        </h2>
  
        <div class="kb-stafet-step__input-wrapper">
  
          <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
            <FormInputTextField
              fieldName="firstName"
              :modelValue="firstName"
              v-model="firstName"
              :label="getLabel('firstNameLabel')"
              :isRequired="isRequired.firstName"
              :isValidationError="displayError && !isFirstNameValid"
              :errorMessageLabel="getLabel('firstNameErrorLabel')"
            />
            <FormInputTextField
              fieldName="lastName"
              :modelValue="lastName"
              v-model="lastName"
              :label="getLabel('lastNameLabel')"
              :isRequired="isRequired.lastName"
              :isValidationError="displayError && !isLastNameValid"
              :errorMessageLabel="getLabel('lastNameErrorLabel')"
              />
          </div>
            
          <FormInputTextField
            fieldName="phone"
            :modelValue="phone"
            v-model="phone"
            :label="getLabel('phoneLabel')"
            :isRequired="isRequired.phone"
            :isValidationError="displayError && !isPhoneValid"
            :errorMessageLabel="getLabel('phoneErrorLabel')"
            />

          <FormAddressField 
            v-model:address-line-value="address"
            v-model:zip-code-value="postalCode"
            v-model:city-value="city"
            :addressLabel="getLabel('addressLabel')"
            :addressPlaceholder="getLabel('addressPlaceholderLabel')"
            :zipCodeLabel="getLabel('postalCodeLabel')"
            :zipCodePlaceholder="getLabel('postalCodePlaceholderLabel')"
            :cityLabel="getLabel('cityLabel')"
            :cityPlaceholder="getLabel('cityPlaceholderLabel')"
            :errorMessageLabel="getLabel('addressErrorLabel')"
            :isValidationError="displayError && !isAddressValid"
            :isRequired="isRequired.address"
          />
  
        </div>
  
      </section>

      <hr v-if="deleteProfileUrl" class="kb-stafet-step__breaker-line kb-stafet-step__breaker-line--smaller"/>
      
      <div v-if="deleteProfileUrl" class="kb-edit-profile-form__delete-wrapper">
        {{ getLabel('deleteProfileLabel') }}
        
        <a v-if="linkToDeleteConfirmationPage" :href="deleteProfileUrl">
          {{ getLabel('deleteProfileLinkText') }}
        </a>
        <a v-else @click="openDeleteOverlay">
          {{ getLabel('deleteProfileLinkText') }}
        </a>
      </div>
      
      <hr class="kb-stafet-step__breaker-line kb-stafet-step__breaker-line--smaller"/>

      <div class="kb-rich-text">
        <div class="kb-rich-text__content" ref="privacyPolicyWrapper"></div>
      </div>

      <div class="kb-fundraise-form__bottom-button-wrapper">
        <a :onClick="cancel" class="kb-fundraise-form__bottom-button kb-button">
          {{ getLabel('cancelButtonText') }}
        </a>
  
        <button
          @click="submit"
          class="kb-fundraise-form__bottom-button submit kb-button kb-button--full-color-spot"
        >
          {{ getLabel('submitButtonText') }}
        </button>
      </div>

      <template v-if="isSubmitting">
        <div class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky">
          </div>
        </div>
      </template>

    </div>

  </article>
</template>
